import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@material-ui/core'
import { ChevronDown as ChevronDownIcon } from 'react-feather'

import useStyles from './styles'

const DetailField = ({ label, value }) => {
  const classes = useStyles()

  if (!value) return null

  return (
    <Box>
      <Typography variant="body2" className={classes.fieldLabel}>
        {label}
      </Typography>
      <Typography variant="body2" className={classes.fieldValue}>
        {value}
      </Typography>
    </Box>
  )
}

DetailField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
}

const InventoryItemCard = ({
  item,
  expanded,
  onChange,
  animateOnEnter = false,
  showRisk = true,
}) => {
  const classes = useStyles()
  const { name, subtitle, iconUrl, details } = item

  return (
    <Accordion
      square
      className={clsx(classes.card, {
        [classes.animatedCard]: animateOnEnter,
      })}
      expanded={expanded}
      onChange={onChange}
    >
      <AccordionSummary expandIcon={<ChevronDownIcon size={20} />}>
        <Box className={classes.summaryContent}>
          {iconUrl ? (
            <img src={iconUrl} alt={name} className={classes.icon} />
          ) : (
            <Box className={classes.iconFallback} />
          )}
          <Box>
            <Typography variant="subtitle1" className={classes.name}>
              {name}
            </Typography>
            {subtitle && (
              <Typography variant="body2" className={classes.subtitle}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <DetailField label="Local de ocorrência" value={details?.departments} />
        <DetailField
          label="Qual a finalidade de uso?"
          value={details?.purpose}
        />
        <DetailField label="Funcionalidades" value={details?.features} />
        <DetailField label="Tipo de operação" value={details?.operationMode} />
        <DetailField
          label="Intervenção humana"
          value={details?.humanIntervention}
        />
        <DetailField
          label="Utiliza dados pessoais"
          value={details?.processesPersonalData}
        />
        {showRisk && (
          <>
            <DetailField label="Nível de risco" value={details?.risk} />
            <DetailField
              label="Categorias de risco"
              value={details?.riskOptions}
            />
          </>
        )}
      </AccordionDetails>
    </Accordion>
  )
}

InventoryItemCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    subtitle: PropTypes.string,
    iconUrl: PropTypes.string,
    details: PropTypes.shape({
      departments: PropTypes.string,
      purpose: PropTypes.string,
      features: PropTypes.string,
      operationMode: PropTypes.string,
      humanIntervention: PropTypes.string,
      processesPersonalData: PropTypes.string,
      risk: PropTypes.string,
      riskOptions: PropTypes.string,
    }),
  }).isRequired,
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
  animateOnEnter: PropTypes.bool,
  showRisk: PropTypes.bool,
}

export default InventoryItemCard
